/**
 * Copyright (c) 2023 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { mobileUtils } from '@blend/consumer-components';
import type { ConnectOptions } from 'twilio-video';

const desktopOptions: ConnectOptions = {
  bandwidthProfile: {
    video: {
      mode: 'collaboration',
      dominantSpeakerPriority: 'standard',
    },
  },
};

const mobileOptions: ConnectOptions = {
  bandwidthProfile: {
    video: {
      mode: 'collaboration',
      maxSubscriptionBitrate: 2500000,
      dominantSpeakerPriority: 'standard',
    },
  },
};

/**
 * The are the recommended options for Twilio Video.
 * @link https://www.twilio.com/docs/video/tutorials/developing-high-quality-video-applications#collaboration-mode
 * @returns {ConnectOptions} The Twilio Video options.
 */
export const getTwilioVideoOptions = (): ConnectOptions => {
  const options = mobileUtils.isMobileDevice() ? mobileOptions : desktopOptions;

  return {
    ...options,
    dominantSpeaker: true,
    maxAudioBitrate: 16000,
    preferredVideoCodecs: [{ codec: 'VP8', simulcast: true }],
    video: { height: 480, frameRate: 24, width: 640 },
    networkQuality: { local: 1, remote: 1 },
  };
};
